new Vue({
    el:'.christma25',
    data(){
        return{
            // 加载完成
            loadFlag:false,
            // 发送验证码标识
            sendFlag:false,
            loginFlag:false,
            popup:false,
            loginPopup:false,
            isSend:false,
            isLogin:false,
            sendText:'Send code',
            findText:'',
            user:{
                name:'',
                email:'',
                code:'',
                chance:0,
                ranking:0,
                country:'Country'
            },
            popup1:false,
            select_flag1:0,
            countryArr:[],
            targetTime: new Date('2025-12-31 23:59:59').getTime(),
            countdown: {
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0
            },
            isPlay:false,
            gameGui:false,
            ranking:[],
            // 游戏界面
            gameStart:false,
        }
    },
    methods:{
        async shareGame(){
            window.open('https://www.facebook.com/sharer/sharer.php?u=https://www.oxbar.com/pages/christmas-treasure')
            if(!JSON.parse(this.user.is_share)){
                let res = await axios.post('https://service.oxvatech.cn/christma/share',{},{
                    headers: { Authorization: `${this.user.token}`}
                });
                if(res.data.status == 200){
                    this.user.chance +=1;
                    this.user.is_share = 'true'
                }else if(res.data.status == 201){
                    showMessage("Shared today, try again tomorrow",'error')
                }
            }else{
                showMessage("Shared today, try again tomorrow",'error')
            }
        },
        async scoreLog(score){
            let params=new URLSearchParams();
            params.append('info',JSON.stringify({points:score}));
            let res = await axios.post('https://service.oxvatech.cn/christma/step',params,{
                headers: { Authorization: `${this.user.token}`}
            });
            if(res.data.status!=200){
                showMessage("Server error, please contact customer service",'error')
            }
        },
        async startGame(id){
            if(this.user.chance>0){
                let res = await axios.post('https://service.oxvatech.cn/christma/start',{},{
                    headers: { Authorization: `${this.user.token}`}
                });
                if(res.data.status==200){
                    if(id!=1){
                        this.gameView()
                        this.gameStart = true
                    }
                    this.user.chance -= 1
                }else{
                    showMessage("There's no chance, go share it now",'error')
                }
            }else{
                showMessage("There's no chance, go share it now",'error')
            }
        },
        async endGame(){
            await axios.post('https://service.oxvatech.cn/christma/end',{},{
                headers: { Authorization: `${this.user.token}`}
            });
            this.getInfo()
        },
        async sendEmail(){
            if(this.user.email == ''){
                showMessage('Please enter your email','error')
                return;
            }
            // 邮箱正则表达式
            var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
            if(!emailReg.test(this.user.email)){
                showMessage('Email format error','error')
                return;
            }
            if(this.sendFlag){
                showMessage('Sent, please try again in one minute.','success')
                setTimeout(() => {
                    this.sendFlag = false
                    this.sendText = 'Send code'
                }, 1000*60);
                return;
            }
            this.sendText = 'Has sent'
            this.sendFlag = true
            var params=new URLSearchParams();
            params.append('info',JSON.stringify(this.user));
            let res = await axios.post('https://service.oxvatech.cn/christma/sendEmail',params);
            if(res.data.status == 200){
                this.isSend = true
                showMessage('Email has been sent, please check.','success')
            }else{
                showMessage('Server error, please contact customer service','error')
            }
        },
        async loginActivity(){
            if(!this.isSend){
                showMessage('Please send the email verification code first','error')
                return;
            }
            if(!this.user.name || !this.user.email || this.user.country == 'Country' || !this.user.code){
                showMessage('Please fill in the information completely','error')
                return;
            }
            // 邮箱正则表达式
            var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
            if(!emailReg.test(this.user.email)){
                showMessage('Email format error','error')
                return;
            }
            //避免重复提交
            if(this.loginFlag) return;
            this.loginFlag = true
            var params=new URLSearchParams();
            params.append('info',JSON.stringify(this.user));
            let res = await axios.post('https://service.oxvatech.cn/christma/loginActivity',params);
            if(res.data.status == 200){
                this.setCookie('_oxbar_christma_',res.data.data,45)
                this.user.token = res.data.data
                showMessage('Good Lucky! ','success')
                this.popup = this.loginPopup = false
                this.getInfo()
                var element = document.querySelector(".svopp_game");
                element.scrollIntoView({behavior: "smooth",block: "start"});
            }else{
                this.loginFlag = false
                let errorMessages = {
                    201: 'Email verification code error',
                    202: 'Username already exists',
                    500:' Server error, please contact customer service',
                };
                showMessage(errorMessages[res.data.status] || 'Unknown error', 'error');
            }
        },
        async getInfo(){
            let res = await axios.post('https://service.oxvatech.cn/christma/getInfo', {}, {
                headers: { Authorization: `${this.user.token}`}
            });
            if(res.data.status == 200){
                if(res.data.data.length>0){
                    this.isLogin = true
                    this.user = res.data.data[0]
                }else{
                    this.isLogin = false
                }
            }else{
                showMessage('server error','error')
            }
        },
        async getData(){
            let res = await axios.get('https://service.oxvatech.cn/public/getAllCountry')
            if(res.status == 200){
                this.countryArr = res.data.data
            }

            let res2 = await axios.get('https://service.oxvatech.cn/christma/getRanking')
            if(res2.status == 200){
                this.ranking = res2.data.data
            }
        },
        // 控件类-------------------------------------------------
        playStart(){
            if(!this.isLogin){
                this.popup = this.loginPopup = true;
                return false;
            }else{
                this.gameGui = true
                var element = document.querySelector(".svopp_game");
                element.scrollIntoView({behavior: "smooth",block: "start"});
            }
        },
        endTips(){
            showMessage('The event has ended, thank you for your participation.','success')
        },
        emailUpdate(){
            if(this.isSend){
                this.isSend = false
                this.sendFlag = false
                this.sendText = 'Send code'
            }
        },
        // 工具类-------------------------------------------------
        QuickFind(){
            var countryList = this.$refs.countryList; // 获取 .country_option 元素
            // 找到第一个以输入字母开头的国家元素
            var targetCountry = Array.from(countryList.children).find((country) =>
                country.textContent.trim().toLowerCase().startsWith(this.findText.toLowerCase())
            );

            if (targetCountry) {
                // 滚动到目标国家
                targetCountry.scrollIntoView({ block: 'start' });
            }
        },
        // cookie
        setCookie(name,value,day){
            var d = new Date();
            d.setTime(d.getTime() + (day * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = name + "=" + value + ";" + expires + ";path=/";
        },
        getCookie(name){
            var name = name + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var cookieArray = decodedCookie.split(';');
            for(let i = 0; i < cookieArray.length; i++) {
                let cookie = cookieArray[i];
                while (cookie.charAt(0) == ' ') {
                cookie = cookie.substring(1);
                }
                if (cookie.indexOf(name) == 0) {
                return cookie.substring(name.length, cookie.length);
                }
            }
            return "";
        },
        // 活动倒计时
        startTime() {
            this.updateCountdown();
            this.allInterval = setInterval(this.updateCountdown, 1000);
        },
        updateCountdown() {
            var currentTime = new Date().getTime();
            var timeDifference = this.targetTime - currentTime;

            if (timeDifference <= 0) {
                this.countdown = { days: 0, hours: 0, minutes: 0, seconds: 0 };
                clearInterval(this.allInterval)
                return;
            }

            var seconds = Math.floor((timeDifference / 1000) % 60);
            var minutes = Math.floor((timeDifference / (1000 * 60)) % 60);
            var hours = Math.floor((timeDifference / (1000 * 60 * 60)) % 24);
            var days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

            this.countdown = { days, hours, minutes, seconds };
        },
        drawSnow(){
            //snow
            let numFlakes = 30; // 雪花数量
            let width = window.innerWidth; // 获取窗口宽度
            let height = window.innerHeight;

            // 创建雪花的函数
            function createFlake() {
                let snowContainer = document.querySelector('.snow') 
                let flake = document.createElement("div");
                let flakeClass = "flake flake" + gsap.utils.random(1,4,1);
                flake.setAttribute("class", flakeClass);
                //document.body.appendChild(flake);
                snowContainer.appendChild(flake)
                return flake;
            }

            // 控制雪花动画的函数
            function animateFlake(flake) {

                // 随机化 x 轴的移动方向
                let xDirection = gsap.utils.random(-1, 1) > 0 ? "+=" : "-=";
                let xDistance = gsap.utils.random(10, 500); // 根据需要调整 x 轴的距离
                

                // 随机产生雪花大小的因子
                let scaleFactor = Power3.easeIn(Math.random()); // 若要修改雪花大小，可修改这里的缩放因子
                let scale = gsap.utils.interpolate(0.4, 1, scaleFactor); // 根据因子调整雪花大小
                let duration = gsap.utils.interpolate(2,20, 1-scaleFactor); // 根据大小因子调整下落速度
                let opacity = gsap.utils.interpolate(0.5, 1, scaleFactor); // 根据大小因子调整雪花透明度

                // 设置雪花的初始位置、大小和透明度
                gsap.set(flake, {y:-200, x:gsap.utils.random(0,width), scale:scale, opacity:1});

                // 控制雪花的运动轨迹、速度和旋转
                gsap.to(flake, {
                    y:height + 200,
                    x:xDirection + xDistance,
                    duration:duration,
                    delay:"random(0,4)",
                    ease:"none",
                    rotation:"random(-60, 200)",
                    onComplete:animateFlake,
                    onCompleteParams:[flake]
                });
            }

            // 循环创建雪花并启动动画
            for(let i = 0; i < numFlakes; i++){
                let flake = createFlake();
                animateFlake(flake);
            }
        },
        gameView(){
            var that = this

            // 游戏的初始化状态和配置
            let status = "waiting";
            let lastTimestamp;
            let santaX;
            let santaY;
            let sceneOffset;
            let score = 0;
            let platforms = [];
            let sticks = [];
            let trees = [];
            let clouds = [];

            // 游戏配置参数
            const config = {
                canvasWidth: 375,
                canvasHeight: 375,
                platformHeight: 100,
                santaDistanceFromEdge: 10,
                paddingX: 100,
                perfectAreaSize: 10,
                backgroundSpeedMultiplier: 0.2,
                speed: 4,
                santaWidth: 17,
                santaHeight: 30
            };

            // 颜色配置
            const colours = {
                lightBg: "#62AFB9",
                medBg: "#182757",
                darkBg: "#0D5B66",
                lightHill: "#E9E9E9",
                medHill: "#34A65F",
                darkHill: "#07133A",
                platform: "#9B4546",
                platformTop: "#620E0E",
                em: "#CC231E",
                skin: "#CF6D60"
            };

            // 山丘配置
            const hills = [
                {
                    baseHeight: 120,
                    amplitude: 20,
                    stretch: 0.5,
                    colour: colours.lightHill
                },
                {
                    baseHeight: 100,
                    amplitude: 10,
                    stretch: 1,
                    colour: colours.medHill
                },
                {
                    baseHeight: 70,
                    amplitude: 20,
                    stretch: 0.5,
                    colour: colours.darkHill
                }
            ];

            const scoreElement = $('.pg_score')[0]
            const canvas = $('#stage')[0]
            const introductionElement = $('.introduction')[0]
            const perfectElement = $('.pg_perfect')[0]
            const restartButton = $('.pg_restart')[0]

            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;

            const ctx = canvas.getContext("2d");

            // 自定义数组方法，用于获取数组的最后一个元素
            Array.prototype.last = function () {
                return this[this.length - 1];
            };

            Math.sinus = function (degree) {
                return Math.sin((degree / 180) * Math.PI);
            };

            // 监听按键事件，空格键重置关卡
            // window.addEventListener("keydown", function (event) {
            //     if (event.key == " ") {
            //         event.preventDefault();
            //         resetGame();
            //         return;
            //     }
            // });

            // 监听鼠标或触屏按下事件
            ["mousedown", "touchstart"].forEach(function (evt) {
                window.addEventListener(evt, function (event) {
                    if (status == "waiting") {
                        lastTimestamp = undefined;
                        introductionElement.style.opacity = 0;
                        status = "stretching";
                        window.requestAnimationFrame(animate);
                    }
                });
            });

            // 监听鼠标或触屏松开事件
            ["mouseup", "touchend"].forEach(function (evt) {
                window.addEventListener(evt, function (event) {
                    if (status == "stretching") {
                        status = "turning";
                    }
                });
            });

            window.addEventListener("resize", function (event) {
                canvas.width = window.innerWidth;
                canvas.height = window.innerHeight;
                draw();
            });

            restartButton.addEventListener("click", function (event) {
                event.preventDefault();
                that.startGame(1)
                resetGame();
                restartButton.style.display = "none";
                $('.pg_chance div').hide()
            });

            // 动画循环调用
            window.requestAnimationFrame(animate);

            resetGame();

            function resetGame() {
                status = "waiting";
                lastTimestamp = undefined;
                sceneOffset = 0;
                score = 0;
                introductionElement.style.opacity = 1;
                perfectElement.style.opacity = 0;
                restartButton.style.display = "none";
                $('.pg_chance div').hide()
                scoreElement.innerText = score;
                platforms = [{ x: 50, w: 50 }];
                santaX = platforms[0].x + platforms[0].w - config.santaDistanceFromEdge;
                santaY = 0;
                sticks = [{ x: platforms[0].x + platforms[0].w, length: 0, rotation: 0 }];
                trees = [];
                clouds = [];

                // 生成初始平台、树木和云朵
                for (let i = 0; i <= 20; i++) {
                    if (i <= 3) generatePlatform();
                    generateTree();
                    generateCloud();
                }

                draw();
            }

            // 生成云朵
            function generateCloud() {
                const minimumGap = 60;
                const maximumGap = 300;

                const lastCloud = clouds[clouds.length - 1];
                let furthestX = lastCloud ? lastCloud.x : 0;

                const x =
                    furthestX +
                    minimumGap +
                    Math.floor(Math.random() * (maximumGap - minimumGap));

                const y =
                    minimumGap +
                    Math.floor(Math.random() * (maximumGap - minimumGap)) -
                    window.innerHeight / 1.2;

                const w = Math.floor(Math.random() * 15 + 15);
                clouds.push({ x, y, w });
            }

            // 生成树木
            function generateTree() {
                const minimumGap = 30;
                const maximumGap = 150;

                const lastTree = trees[trees.length - 1];
                let furthestX = lastTree ? lastTree.x : 0;

                const x =
                    furthestX +
                    minimumGap +
                    Math.floor(Math.random() * (maximumGap - minimumGap));

                const treeColors = [colours.lightHill, colours.medBg, colours.medHill];
                const color = treeColors[Math.floor(Math.random() * 3)];

                trees.push({ x, color });
            }

            // 生成平台
            function generatePlatform() {
                const minimumGap = 40;
                const maximumGap = 200;
                const minimumWidth = 20;
                const maximumWidth = 100;

                const lastPlatform = platforms[platforms.length - 1];
                let furthestX = lastPlatform.x + lastPlatform.w;

                const x =
                    furthestX +
                    minimumGap +
                    Math.floor(Math.random() * (maximumGap - minimumGap));
                const w =
                    minimumWidth + Math.floor(Math.random() * (maximumWidth - minimumWidth));

                platforms.push({ x, w });
            }

            // 动画函数，根据时间戳更新状态并渲染游戏
            function animate(timestamp) {
                if (!lastTimestamp) {
                    lastTimestamp = timestamp;
                    window.requestAnimationFrame(animate);
                    return;
                }

                switch (status) {
                    case "waiting":
                        return;
                    case "stretching": {
                        sticks.last().length += (timestamp - lastTimestamp) / config.speed;
                        break;
                    }
                    case "turning": {
                        sticks.last().rotation += (timestamp - lastTimestamp) / config.speed;

                        if (sticks.last().rotation > 90) {
                            sticks.last().rotation = 90;

                            const [nextPlatform, perfectHit] = thePlatformTheStickHits();
                            if (nextPlatform) {
                                score += perfectHit ? 2 : 1;
                                that.scoreLog(score)
                                scoreElement.innerText = score;

                                if (perfectHit) {
                                    perfectElement.style.opacity = 1;
                                    setTimeout(() => (perfectElement.style.opacity = 0), 1000);
                                }

                                generatePlatform();
                                generateTree();
                                generateTree();

                                generateCloud();
                                generateCloud();
                            }

                            status = "walking";
                        }
                        break;
                    }
                    case "walking": {
                        santaX += (timestamp - lastTimestamp) / config.speed;

                        const [nextPlatform] = thePlatformTheStickHits();
                        if (nextPlatform) {
                            const maxSantaX =
                                nextPlatform.x + nextPlatform.w - config.santaDistanceFromEdge;
                            if (santaX > maxSantaX) {
                                santaX = maxSantaX;
                                status = "transitioning";
                            }
                        } else {
                            const maxSantaX =
                                sticks.last().x + sticks.last().length + config.santaWidth;
                            if (santaX > maxSantaX) {
                                santaX = maxSantaX;
                                status = "falling";
                                if(score>0){
                                    that.endGame()
                                }
                            }
                        }
                        break;
                    }
                    case "transitioning": {
                        sceneOffset += (timestamp - lastTimestamp) / (config.speed / 2);

                        const [nextPlatform] = thePlatformTheStickHits();
                        if (sceneOffset > nextPlatform.x + nextPlatform.w - config.paddingX) {
                            sticks.push({
                                x: nextPlatform.x + nextPlatform.w,
                                length: 0,
                                rotation: 0
                            });
                            status = "waiting";
                        }
                        break;
                    }
                    case "falling": {
                        if (sticks.last().rotation < 180)
                            sticks.last().rotation += (timestamp - lastTimestamp) / config.speed;

                        santaY += (timestamp - lastTimestamp) / (config.speed / 2);
                        const maxSantaY =
                            config.platformHeight +
                            100 +
                            (window.innerHeight - config.canvasHeight) / 2;
                        if (santaY > maxSantaY) {
                            restartButton.style.display = "block";
                            $('.pg_chance div').show()
                            return;
                        }
                        break;
                    }
                    default:
                        throw Error("Wrong status");
                }

                draw();
                window.requestAnimationFrame(animate);

                lastTimestamp = timestamp;
            }

            // 检查棍子是否与平台碰撞，并返回命中的平台和是否完美命中的信息
            function thePlatformTheStickHits() {
                if (sticks.last().rotation != 90)
                    throw Error(`Stick is ${sticks.last().rotation}°`);
                const stickFarX = sticks.last().x + sticks.last().length;

                const platformTheStickHits = platforms.find(
                    (platform) => platform.x < stickFarX && stickFarX < platform.x + platform.w
                );

                if (
                    platformTheStickHits &&
                    platformTheStickHits.x +
                    platformTheStickHits.w / 2 -
                    config.perfectAreaSize / 2 <
                    stickFarX &&
                    stickFarX <
                    platformTheStickHits.x +
                    platformTheStickHits.w / 2 +
                    config.perfectAreaSize / 2
                )
                    return [platformTheStickHits, true];

                return [platformTheStickHits, false];
            }

            // 绘制游戏的所有元素
            function draw() {
                ctx.save();
                ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
                drawBackground();
                ctx.translate(
                    (window.innerWidth - config.canvasWidth) / 2 - sceneOffset,
                    (window.innerHeight - config.canvasHeight) / 2
                );

                drawPlatforms();
                drawSanta();
                drawSticks();

                ctx.restore();
            }

            // 绘制平台
            function drawPlatforms() {
                platforms.forEach(({ x, w }) => {
                    let newX = x + 3;
                    let newW = w - 6;
                    let platformHeight =
                        config.platformHeight + (window.innerHeight - config.canvasHeight) / 2;
                    ctx.fillStyle = colours.platform;
                    ctx.fillRect(
                        newX,
                        config.canvasHeight - config.platformHeight,
                        newW,
                        platformHeight
                    );

                    for (let i = 1; i <= platformHeight / 10; ++i) {
                        let yGap = config.canvasHeight - config.platformHeight + i * 10;
                        ctx.moveTo(newX, yGap);
                        ctx.lineTo(newX + newW, yGap);
                        let xGap = i % 2 ? 0 : 10;
                        for (let j = 1; j < newW / 30; ++j) {
                            let x = j * 20 + xGap;
                            ctx.moveTo(newX + x, yGap);
                            ctx.lineTo(newX + x, yGap + 10);
                        }
                        ctx.strokeStyle = colours.platformTop;
                        ctx.stroke();
                    }

                    ctx.fillStyle = colours.platformTop;
                    ctx.fillRect(x, config.canvasHeight - config.platformHeight, w, 10);

                    if (sticks.last().x < x) {
                        ctx.fillStyle = "white";
                        ctx.fillRect(
                            x + w / 2 - config.perfectAreaSize / 2,
                            config.canvasHeight - config.platformHeight,
                            config.perfectAreaSize,
                            config.perfectAreaSize
                        );
                    }
                });
            }

            // 绘制圣诞老人
            function drawSanta() {
                ctx.save();
                ctx.fillStyle = "red";
                ctx.translate(
                    santaX - config.santaWidth / 2,
                    santaY +
                    config.canvasHeight -
                    config.platformHeight -
                    config.santaHeight / 2
                );

                ctx.fillRect(
                    -config.santaWidth / 2,
                    -config.santaHeight / 2,
                    config.santaWidth,
                    config.santaHeight - 4
                );

                const legDistance = 5;
                ctx.beginPath();
                ctx.arc(legDistance, 11.5, 3, 0, Math.PI * 2, false);
                ctx.fill();
                ctx.beginPath();
                ctx.arc(-legDistance, 11.5, 3, 0, Math.PI * 2, false);
                ctx.fill();

                ctx.beginPath();
                ctx.fillStyle = colours.skin;
                ctx.arc(5, -7, 3, 0, Math.PI * 2, false);
                ctx.fill();

                ctx.beginPath();
                ctx.fillStyle = "white";
                ctx.arc(7, -2, 3, 0, Math.PI * 2, false);
                ctx.fill();

                ctx.beginPath();
                ctx.fillStyle = "red";
                ctx.moveTo(-8, -13.5);
                ctx.lineTo(-15, -3.5);
                ctx.lineTo(-5, -7);
                ctx.fill();

                ctx.fillStyle = "white";
                ctx.fillRect(-config.santaWidth / 2, -12, config.santaWidth, 3);

                ctx.fillStyle = "black";
                ctx.fillRect(-config.santaWidth / 2, 2, config.santaWidth, 2);
                ctx.fillStyle = "white";
                ctx.fillRect(-config.santaWidth / 2, 4, config.santaWidth, 4.5);

                ctx.beginPath();
                ctx.fillStyle = "white";
                ctx.arc(-17, -2, 3, 0, Math.PI * 2, false);
                ctx.fill();

                ctx.restore();
            }

            // 绘制棍子
            function drawSticks() {
                sticks.forEach((stick) => {
                    ctx.save();

                    ctx.translate(stick.x, config.canvasHeight - config.platformHeight);
                    ctx.rotate((Math.PI / 180) * stick.rotation);

                    ctx.beginPath();
                    ctx.lineWidth = 4;
                    ctx.moveTo(0, 0);
                    ctx.lineTo(0, -stick.length);

                    ctx.strokeStyle = ctx.createPattern(createCandyPattern(), "repeat");
                    ctx.stroke();

                    ctx.restore();
                });
            }

            // 绘制背景
            function drawBackground() {
                var gradient = ctx.createRadialGradient(
                    window.innerWidth / 2,
                    window.innerHeight / 2,
                    0,
                    window.innerHeight / 2,
                    window.innerWidth / 2,
                    window.innerWidth
                );
                gradient.addColorStop(0, colours.lightBg);
                gradient.addColorStop(1, colours.darkBg);
                ctx.fillStyle = gradient;
                ctx.fillRect(0, 0, window.innerWidth, window.innerHeight);

                hills.forEach((hill) =>
                    drawHill(hill.baseHeight, hill.amplitude, hill.stretch, hill.colour)
                );
                trees.forEach((tree) => drawTree(tree.x, tree.color));
                clouds.forEach((cloud) => drawCloud(cloud.x, cloud.y, cloud.w));
            }

            // 绘制山丘
            function drawHill(baseHeight, amplitude, stretch, color) {
                ctx.beginPath();
                ctx.moveTo(0, window.innerHeight);
                ctx.lineTo(0, getHillY(0, baseHeight, amplitude, stretch));
                for (let i = 0; i < window.innerWidth; i++) {
                    ctx.lineTo(i, getHillY(i, baseHeight, amplitude, stretch));
                }
                ctx.lineTo(window.innerWidth, window.innerHeight);
                ctx.fillStyle = color;
                ctx.fill();
            }

            // 绘制树木
            function drawTree(x, color) {
                ctx.save();
                ctx.translate(
                    (-sceneOffset * config.backgroundSpeedMultiplier + x) * hills[1].stretch,
                    getTreeY(x, hills[1].baseHeight, hills[1].amplitude)
                );

                const treeTrunkHeight = 15;
                const treeTrunkWidth = 10;
                const treeCrownHeight = 60;
                const treeCrownWidth = 30;

                // Draw trunk
                ctx.fillStyle = colours.darkHill;
                ctx.fillRect(
                    -treeTrunkWidth / 2,
                    -treeTrunkHeight,
                    treeTrunkWidth,
                    treeTrunkHeight
                );

                // Draw crown
                ctx.beginPath();

                ctx.moveTo(-treeCrownWidth / 2, -treeTrunkHeight * 3);
                ctx.lineTo(0, -(treeTrunkHeight + treeCrownHeight));
                ctx.lineTo(treeCrownWidth / 2, -treeTrunkHeight * 3);

                ctx.moveTo(-treeCrownWidth / 2, -treeTrunkHeight * 2);
                ctx.lineTo(0, -(treeTrunkHeight / 2 + treeCrownHeight));
                ctx.lineTo(treeCrownWidth / 2, -treeTrunkHeight * 2);

                ctx.moveTo(-treeCrownWidth / 2, -treeTrunkHeight);
                ctx.lineTo(0, -(treeTrunkHeight + treeCrownHeight / 2));
                ctx.lineTo(treeCrownWidth / 2, -treeTrunkHeight);

                ctx.fillStyle = color;
                ctx.fill();

                ctx.restore();
            }

            // 绘制云朵
            function drawCloud(x, y, width) {
                ctx.save();
                ctx.translate(
                    (-sceneOffset * config.backgroundSpeedMultiplier + x) * hills[1].stretch,
                    getTreeY(x, hills[1].baseHeight, hills[1].amplitude)
                );

                height = width * 1.5;
                ctx.beginPath();
                ctx.arc(x, y, width, Math.PI * 0.5, Math.PI * 1.5);
                ctx.arc(x + height, y - width, height, Math.PI * 1, Math.PI * 2);
                ctx.arc(x + height * 2, y - width, height, Math.PI * 1.2, Math.PI);
                ctx.arc(x + width * 3, y, width, Math.PI * 1.5, Math.PI * 0.5);
                ctx.moveTo(x + width * 3, y + width);
                ctx.lineTo(x, y + width);
                ctx.fillStyle = "rgba(255, 255, 255, .3)";
                ctx.fill();

                ctx.restore();
            }

            // 创建糖果纹理用于棍子的装饰
            function createCandyPattern() {
                const patternCanvas = document.createElement("canvas");
                const pctx = patternCanvas.getContext("2d");

                const max = 15;
                let i = 0;
                let x = 0;
                let z = 90;

                while (i < max) {
                    pctx.beginPath();
                    pctx.moveTo(0, x);
                    pctx.lineTo(0, z);
                    pctx.lineWidth = 24;
                    pctx.strokeStyle = "red";
                    pctx.stroke();

                    pctx.beginPath();
                    pctx.moveTo(0, x + 24);
                    pctx.lineTo(0, z + 24);
                    pctx.lineWidth = 24;
                    pctx.strokeStyle = "white";
                    pctx.stroke();

                    x += 48;
                    z += 48;
                    i++;
                }

                return patternCanvas;
            }

            // 获取山丘的Y坐标
            function getHillY(windowX, baseHeight, amplitude, stretch) {
                const sineBaseY = window.innerHeight - baseHeight;
                return (
                    Math.sinus(
                        (sceneOffset * config.backgroundSpeedMultiplier + windowX) * stretch
                    ) *
                    amplitude +
                    sineBaseY
                );
            }

            // 获取树木的Y坐标
            function getTreeY(x, baseHeight, amplitude) {
                const sineBaseY = window.innerHeight - baseHeight;
                return Math.sinus(x) * amplitude + sineBaseY;
            }

            // 创建元素并应用样式
            function createElementStyle(element, cssStyles = null, inner = null) {
                const g = document.createElement(element);
                if (cssStyles) g.style.cssText = cssStyles;
                if (inner) g.innerHTML = inner;
                document.body.appendChild(g);
                return g;
            }
        }

    },
    created(){
        // 加载完成后 更新弹窗显示样式
        this.loadFlag = true
        //判断登录状态
        if(this.getCookie('_oxbar_christma_')){
            this.isLogin = true
            this.user.token = this.getCookie('_oxbar_christma_')
            //获取用户信息
            this.getInfo()
        }
        this.getData()
        this.startTime();
    },
    mounted(){
        this.drawSnow()
        var wFlag = window.innerWidth>750

        function showUp(dom){
            gsap.from(dom,{
                y:'2rem',opacity:0,ease:'none',duration:0.5,
                scrollTrigger:{
                    trigger:dom,
                    start:'top bottom-=20%',
                    end:'+=0',
                    //toggleActions:'play none none reverse',
                }
            })
        }

        showUp('.box2_title')
    
        showUp('.box3_title')
        showUp('.box3_prize div')
    
        showUp('.box4_title')
    }
})